// extracted by mini-css-extract-plugin
export default {"title":"c4d542c416","inner_title":"_70958d205c","charge_btn":"_2191293c30"};